<div *ngIf="loading" style="display: flex;justify-content: center;align-items: center;height: 20vh;"> <img src="assets/images/cinejoy/loader.gif" style="width: 95px; height: 56px" />
</div>
<div style="position: relative;">
  <!--*ngIf="!exsistingGroup && !loading && isBuyButtonActive"-->
  <li class="join-container" *ngIf="!loading && isBuyButtonActive" >
    <h2 mat-dialog-title class="cus-title"><ng-container *ngIf="!exsistingGroup">Create</ng-container><ng-container *ngIf="exsistingGroup">Edit</ng-container> a Group to share Spotlight experience <p *ngIf="data.isPreScheduleEvent">{{cinejoyPremierDetails?.name}}</p></h2>
    <div class="bottom-sheet-header">
      <img style="width: 20px;cursor: pointer;position: absolute;right: 2px;right: -15px;top: -11px;"  (click)="closeDialog()" src="assets/icons/group-sharing/cancel-white.svg"
     ></div>
    <div fxLauout="column">
      <div style="margin-bottom: 5%;">
        <label>Enter Group name</label>
        <input placeholder="e.g Creatics Rockerz" [(ngModel)]="groupName" class="form-control"
          (change)="checkValidValue($event.target)">
          <span class="span-label"  *ngIf="!invalidGroupName">(Enter Minimum 3 character and Maximum of 30 characters.) </span>

        <span class="err-msg" *ngIf="invalidGroupName">Enter a valid Group name with minimum 3 character and 30 character maximum. </span>
      </div>
      <div style="margin-bottom: 5%;">
        <label>Enter Username OR Email ID</label>
        <mat-form-field class="example-chip-list" appearance="fill">
          <mat-label>Add Group Participants</mat-label>
          <mat-chip-list #chipList aria-label="Fruit selection">
            <mat-chip *ngFor="let fruit of selectedUsers" (removed)="remove(fruit)">
              {{fruit.name}}
              <span matChipRemove><img src="assets/icons/group-sharing/cancel.svg" alt="" style="width:20px;" (click)="remove(fruit)"></span>
            </mat-chip>
            <mat-chip matTooltip="This user will be invited to Creatics" style="background: rgb(150, 220, 150);" *ngFor="let invitedUser of invitedEmails" (removed)="removeInvitation(invitedUser)">
              {{ invitedUser }}
              <span matChipRemove><img src="assets/icons/group-sharing/cancel.svg" alt="" style="width:20px;"></span>
            </mat-chip>
            <input class="cus-search-users" placeholder="Enter User Name or Email" #fruitInput [formControl]="myControl" [value]="myControl.value"
              [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             >
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedItems($event)">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.userId">
              {{option.value}}
            </mat-option>
            <mat-option *ngIf="!filterHasLength && email && myControl.value">
              <button type="button" mat-raised-button color="primary"
                class="ms-2"
                (click)="inviteUser($event)" style="background: #de1b36;">Invite User</button>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <span class="err-msg" *ngIf="invalidUserIds">Enter a valid User Name to be part of group sharing experience
        </span>
      </div>
    </div>
    <div style="margin-top: 5%;" class="cus-btn-sec">
      <button mat-raised-button color="primary" (click)="getCustomRoomId()"
        style="margin-left: 5px;background: #de1b36;" *ngIf="!exsistingGroup">Create</button>
        <button mat-raised-button color="primary" (click)="updateEvent()"
        style="margin-left: 5px;background: #de1b36;" *ngIf="exsistingGroup">Update</button>
        <button mat-raised-button color="primary" (click)="deleteGroup()"
        style="margin-left: 5px;background: #de1b36;" *ngIf="exsistingGroup ">Delete</button>
      <button mat-raised-button color="primary" style="margin-left: 5px;background: #de1b36;width: 95px;"
        (click)="closeDialog()">Cancel</button>

    </div>
  </li>

  <li class="join-container" *ngIf="exsistingGroup && !loading && isBuyButtonActive">
    <!-- <h2 mat-dialog-title>Join Existing Group</h2>
    <div class="bottom-sheet-header">
      <img style="width: 20px;cursor: pointer;position: absolute;right: 7px;top:7px"  (click)="closeDialog()" src="assets/icons/group-sharing/cancel-white.svg"
     ></div>
    <div fxLayout="column">
      <p> You have already created a Group for this Spotlight Event. Once this event goes live, you can join, start your Group, and add more invitees if you like. </p>

    </div> -->

    <div  class="cus-btn-sec" *ngIf="!exsistingGroup && isBuyButtonActive">
      <button mat-raised-button color="primary" (click)="getActiveParties()"
        style="margin-left: 5px;background: #de1b36;width: 100%;">Create</button>
      <button mat-raised-button color="primary" style="margin-left: 5px;background: #de1b36;width: 95px;"
        (click)="closeDialog()">Cancel</button>
    </div>
  </li>

  <li class="join-container" *ngIf="!isBuyButtonActive && !loading">
    <h2 mat-dialog-title>Join Group</h2>
    <div fxLayout="column">
      <p *ngIf="!isBuyButtonActive">{{message}}
        <a (click)="redirectUserBuyTicket()" style="color: red;cursor:pointer"> Click here </a> to purchase the movie.
      </p>
    </div>
  </li>
  <h5 *ngIf="data.isPreScheduleEvent" style="margin-top: 15px; font-family: 'Poppins Regular' !important;">Note: You can begin accessing this group and
    spotlight event on {{startDate | date:'MMM d y, h:mm a'}} - {{endDate | date:'MMM d y, h:mm a'}} {{timezone}}</h5>
  <h5 *ngIf="data.isPreScheduleEvent" style="margin-top: 15px; font-family: 'Poppins Regular' !important;">
    Info:
    Invite participants to your group by either entering their Creatics username or adding their valid email address.
    After adding an email, click the "Invite User" button to include them on the list.
    Newly added participants will be highlighted in light green for easy identification.
    To finalize the invitation, click on "Save Changes" to confirm their inclusion.
    All Invited participants will receive an email to RSVP which can be tracked above, and also, non-members will be prompted to create a FREE Creatics account to access the spotlight event.
    ALL PARTICIPANTS HAVE TO BUY THEIR OWN TICKETS.
  </h5>
  <a class="spotLightsTitle" style="font-size: 14px;" [href]="groupshareUrl" target="_blank"  style="color: rgb(247, 247, 247);cursor:pointer">How-To Experience Spotlights in a Group</a>

</div>
